/**
 *
 * Button.js
 *
 * A common button, if you pass it a prop "route" it'll render a link to a react-router route
 * otherwise it'll render a link with an onclick
 */

import React, { Children } from "react";
import Button from "@material-ui/core/Button";
import "./style.css";

const GTLabel = (props) => {
  return <label className="GTLabel">{props.title}</label>;
};

export default GTLabel;
